if (!customElements.get('tah-santa-group')) {
  customElements.define('tah-santa-group', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.form = this.closest('form');
      if (!this.root || !this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-santa-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-santa-labels]').textContent);
      this.records = [];
      this.uniform = {name:'',font:'',thread:''};
      this.rows = this.querySelector('[data-santa-rows]');
      this.firstRow = this.querySelector('[data-santa-first]');
      this.restRows = this.querySelector('[data-santa-rest]');
      this.items = this.querySelector('[data-santa-items]');
      this.same = this.querySelector('[data-same-all]');
      this.sameControl = this.querySelector('[data-same-control]');
      this.sameHint = this.querySelector('[data-same-hint]');
      this.addHat = this.querySelector('[data-add-hat]');
      this.template = this.querySelector('[data-santa-row]');
      this.count = -1;
      this.mode = null;
      this.active = false;
      this.onChange = event => {
        if (event.target === this.same) {
          if (this.same.checked && this.records[0]) this.uniform = {...this.records[0]};
          if (!this.same.checked) this.records[0] = {...this.uniform};
          this.sync(true);
        } else if (this.contains(event.target) && event.target.dataset.field) {
          const row = event.target.closest('[data-index]');
          const record = this.same.checked ? this.uniform : this.records[Number(row.dataset.index)];
          record[event.target.dataset.field] = event.target.value;
          event.target.setCustomValidity('');
          this.buildItems();
        } else if (!this.contains(event.target)) this.sync();
      };
      this.onVariant = () => queueMicrotask(() => this.sync());
      this.onSubmit = event => {
        if (!this.active) return;
        this.buildItems();
        for (const field of this.rows.querySelectorAll('input,select')) {
          if (field.dataset.field === 'name') field.setCustomValidity(field.value.trim() ? '' : this.labels.required);
          if (!field.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
        }
      };
      this.onFormData = event => {
        if (!this.active) return;
        event.formData.delete('id');
        event.formData.delete('quantity');
        event.formData.delete('properties[Embroidery text]');
      };
      this.form.addEventListener('formdata',this.onFormData);
      this.onClick = event => {
        if (event.target.closest('[data-add-hat]')) {
          event.preventDefault();
          const quantity = this.root.querySelector('input[name="quantity"]');
          quantity.value = String(this.count + 1);
          quantity.dispatchEvent(new Event('input',{bubbles:true}));
          quantity.dispatchEvent(new Event('change',{bubbles:true}));
          [...this.rows.querySelectorAll('fieldset input[data-field="name"]')].at(-1)?.focus();
        } else if (event.target.closest('[name="add"]')) this.onSubmit(event);
      };
      this.root.addEventListener('change',this.onChange);
      this.root.addEventListener('input',this.onChange);
      document.addEventListener('variant:changed',this.onVariant);
      this.form.addEventListener('submit',this.onSubmit,true);
      this.root.addEventListener('click',this.onClick,true);
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change',this.onChange);
      this.root?.removeEventListener('input',this.onChange);
      document.removeEventListener('variant:changed',this.onVariant);
      this.form?.removeEventListener('submit',this.onSubmit,true);
      this.form?.removeEventListener('formdata',this.onFormData);
      this.root?.removeEventListener('click',this.onClick,true);
    }
    sync(force=false) {
      const active = this.root.querySelector('select[name="options[Style]"]')?.value === 'Personalized';
      const raw = Number(this.root.querySelector('input[name="quantity"]')?.value);
      const count = Number.isSafeInteger(raw) && raw > 0 ? raw : 1;
      const same = this.same.checked;
      if (!active) {
        if (this.active) {
          this.records = [];
          this.uniform = {name:'',font:'',thread:''};
          this.same.checked = false;
        }
        this.active = false;
        this.hidden = true;
        this.firstRow.replaceChildren();
        this.restRows.replaceChildren();
        this.items.replaceChildren();
        this.count = -1;
        this.mode = null;
        return;
      }
      this.active = true;
      this.hidden = false;
      this.sameHint.hidden = !same;

      if (force || count !== this.count || same !== this.mode) {
        this.count = count;
        this.mode = same;
        const firstContent = document.createDocumentFragment();
        const content = document.createDocumentFragment();
        const numberOfRows = same ? 1 : count;
        for (let index=0;index<numberOfRows;index++) {
          if (!this.records[index]) this.records[index] = {name:'',font:'',thread:''};
          const record = same ? this.uniform : this.records[index];
          const fragment = this.template.content.cloneNode(true);
          const row = fragment.querySelector('fieldset');
          row.dataset.index = String(index);
          row.querySelector('legend').textContent = same ? 'H1 — '+this.labels.all+' ('+count+')' : 'H'+(index+1);
          for (const field of row.querySelectorAll('[data-field]')) {
            field.value = record[field.dataset.field];
            field.id = this.id+'-'+index+'-'+field.dataset.field;
          }
          if (index === 0) firstContent.append(fragment);
          else content.append(fragment);
        }
        this.firstRow.replaceChildren(firstContent);
        this.restRows.replaceChildren(content);
      }
      this.buildItems();
    }
    buildItems() {
      const fragment = document.createDocumentFragment();
      if (this.active) {
        const records = this.same.checked ? [this.uniform] : this.records.slice(0,this.count);
        records.forEach((record,index) => {
          const variant = this.variants.find(v=>v.style==='Personalized' && v.font===record.font && v.thread===record.thread);
          const values = {
            id: variant ? String(variant.id) : '',
            quantity: this.same.checked ? String(this.count) : '1',
            'properties[Embroidery text]': record.name.trim()
          };
          if (!this.same.checked) values['properties[Hat]'] = 'H'+(index+1);
          for (const [key,value] of Object.entries(values)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'items['+index+']['+key.replace('properties[','properties][');
            if (!key.startsWith('properties[')) input.name += ']';
            input.value = value;
            fragment.append(input);
          }
        });
      }
      this.items.replaceChildren(fragment);
    }
  });
}